import axiosInstance from "../lib/axiosInstance";

class homepagelayoutModel {
  constructor() {
    this.base_url = "/homepage_layout";
    this.base_url1 = "/homepage_content";
  }
  async list(query = []) {
    return (
      await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)
    ).data;
  }
  async create(data = []) {
    return await axiosInstance.post(this.base_url, data);
  }
  async update(id, data = []) {
    return await axiosInstance.post(`${this.base_url}/${id}?_method=PUT`, data);
  }
  async destroy(id, data = []) {
    return await axiosInstance.delete(`${this.base_url}/${id}`, data);
  }
  async show(id) {
    return (await axiosInstance.get(`${this.base_url}/${id}`)).data;
  }

  async updatepositionshomepage(data = []) {
    return await axiosInstance.post(`${this.base_url}/bulk-update`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  async updatepositions(data = []) {
    return await axiosInstance.post(`${this.base_url1}/bulk-update`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
}

export default new homepagelayoutModel();
